import React, { useState } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from 'moment-timezone';

import { getJobBoardTranslate, getJobLogEntries, getJobMessageHistory, getNoteTranslate } from "../../utilities/job";
import { basicAction } from "../../actions";
import { JOB_BOARD_SHOW_LOG_WINDOW } from "../../constants/actionTypes";
import JobBoardJobLogEntryTime from "./JobBoardJobLogEntryTime";
import SvgIcons from '../Icons/SvgIcons';
import { loadPingWidget, removePingWidget } from '../../utilities/pingWidget';

const getEntryIntlKey = (logEntry) => {
  if (logEntry.newStatus && logEntry.oldStatus) {
    switch (logEntry.type) {
      case "ChangeLeadType":
        return "jobBoard.leadType."
      case "ChangeJobStatus":
        return "jobBoard.jobStatuses."
      default:
        return ""
    }
  }
}

const JobBoardJobLogEntries = (props) => {
  const [activeTab, setActiveTab] = useState("JOB LOG");

  const { job, intl, showLogWindow, loadingLogEntries, loadingMessageHistory, pingPilotAuthToken, fabricatorId, language } = props;

  const editClick = (logEntry) => {
    showLogWindow({
      jobId: job.id,
      action: 'update',
      show: true,
      logEntry,
      status: logEntry.newStatus,
      type: job.type
    })
  }

  const logEntries = getJobLogEntries(job, true);
  const messageHistory = getJobMessageHistory(job, true);

  const getMessageSections = () => {
    return messageHistory.filter(mh => mh.relatedEntityType.toLowerCase() === 'fabricator').map(mh => mh.fabricatorType.toUpperCase());
  }

  const capitalizeFirstLetter = (string) => {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const popUpPingWidget = (selectedRole) => {
    removePingWidget();

    let fields = [];
    if(selectedRole === "CUSTOMER"){
      fields['data-clientemail'] = job.customerInfo.email;
      fields['data-clientphone'] = job.customerInfo.phone;
    }

    if(selectedRole === 'INSTALLER'){
      fields['data-signal'] = '138892';
    }

    if(selectedRole === 'SUPPLIER'){
      fields['data-signal'] = '192632';
    }

    if(selectedRole === 'STORE'){
      fields['data-signal'] = '139043';
    }

    loadPingWidget({
      id: "pingpilot",
      type: 'text/javascript',
      async: '',
      'data-token': pingPilotAuthToken,
      'data-jobid': job.id,
      'data-fabricatorid': fabricatorId,
      'data-language': language,
      'data-fabricatortype': selectedRole,
      ...fields
      //add the rest here
    });

    setTimeout(() => {
      const pingButton = document.querySelector(".pingpilot-button");
      if (!pingButton) {
        return null
      }
      pingButton.click();
    }, 2000);


  }

  let currentActiveIndex = logEntries.findIndex((entry) => {
    return ((entry.type === "ChangeLeadType") || (entry.type === "ChangeJobStatus"))
  }) // this should return first found entry that has status or lead change (first in the array - means the last updated)

  if (currentActiveIndex === -1) {
    currentActiveIndex = 0
  }

  const renderMessageHistory = (actorType) => {
    let messages = [];
    if (actorType === 'CUSTOMER') {
      messageHistory.filter(record => record.relatedEntityType.toLowerCase() === 'client')
        .map(mh => mh.messages.map(message => messages.push(message)));
    } else {
      messageHistory.filter(record => record.fabricatorType && record.fabricatorType.toLowerCase() === actorType.toLowerCase())
        .map(mh => mh.messages.map(message => messages.push(message)));
    }
    messages = messages.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

    return (
      <div>
        <ul className="fix-ul">
          {messages.map(message => {
            const entryTime = moment(message.timestamp);
            return (
              <li className="job-board-message text-left" key={message.id}>
                <div className={"job-board-message-lir"}>
                  <div className="job-board-message-lir__time">
                    {entryTime.format('MM-DD-YYYY')} @{entryTime.format('HH:mm:ss')}
                  </div>
                  <div className="job-board-message-lir__message">
                    <span>{message.actor}: </span>
                    <span>{message.content}</span>
                  </div>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    );
  }

  const renderSections = () => {
    const messageSections = getMessageSections();
    const clientMessageHistory = messageHistory.filter(mh => mh.relatedEntityType.toLowerCase() === 'client');
    return (
      <div className="job-board-log-sections">
        <span className={`job-board-log-sections--item ${activeTab === "JOB LOG" ? "job-board-log-sections--item_active" : ""}`}
          onClick={() => setActiveTab("JOB LOG")}>JOB LOG</span>
        {clientMessageHistory.length > 0 ? <span className={`job-board-log-sections--item ${activeTab === "CUSTOMER" ? "job-board-log-sections--item_active" : ""}`}
          onClick={() => setActiveTab("CUSTOMER")}>CUSTOMER</span> : null}
        {messageSections.includes("INSTALLER") ? <span className={`job-board-log-sections--item ${activeTab === "INSTALLER" ? "job-board-log-sections--item_active" : ""}`}
          onClick={() => setActiveTab("INSTALLER")}>INSTALLER</span> : null}
        {messageSections.includes("SUPPLIER") ? <span className={`job-board-log-sections--item ${activeTab === "SUPPLIER" ? "job-board-log-sections--item_active" : ""}`}
          onClick={() => setActiveTab("SUPPLIER")}>SUPPLIER</span> : null}
        {messageSections.includes("STORE") ? <span className={`job-board-log-sections--item ${activeTab === "STORE" ? "job-board-log-sections--item_active" : ""}`}
          onClick={() => setActiveTab("STORE")}>STORE</span> : null}
      </div>
    );
  }

  if (loadingLogEntries || loadingMessageHistory) {
    return <div className="job-board-rollout-col job-board-rollout-col--col3">
      <div className="ui-loader" />
    </div>
  }

  return (
    <div className="job-board-rollout-col job-board-rollout-col--col3">
      <div className='job-board-info-header'>
        {renderSections()}
        {activeTab !== "JOB LOG"
          ? <div className='job-board-info-header-contact' onClick={() => popUpPingWidget(activeTab)}>
            <div className='job-board-info-header-contact-icon'>{SvgIcons.contact}</div>
            <span>
              Contact {capitalizeFirstLetter(activeTab)}
            </span>
          </div>
          : null
        }
      </div>
      {activeTab === "JOB LOG"
        ? <ul className="fix-ul">
          {logEntries.map((logEntry, logEntryIndex) => {
            const disabledEdit = logEntry.id === 1;
            const browserTimeZone = moment.tz.guess();
            const entryTime = disabledEdit ? moment(logEntry.timestamp) : moment.utc(logEntry.timestamp).tz(browserTimeZone);
            const isDead = logEntry.newStatus === "Dead Lead";
            const isCompleted = logEntry.newStatus === "Completed";
            return (
              <li className="job-board-message text-left" key={logEntry.timestamp}>
                <div className={"job-board-message-lir"
                  + (isDead ? " job-board-message-lir--red" : "")
                  + (currentActiveIndex === logEntryIndex ? " job-board-message-lir--blue" : "")
                  + (isCompleted ? " job-board-message-lir--green" : "")}>
                  <div className="job-board-message-edit-log">
                    {disabledEdit ? null : (
                      <button className={"job-board-message-edit-log-button"
                        + (isDead || isCompleted ? " job-board-message-edit-log-button--white" : "")}
                        onClick={() => editClick(logEntry)} />
                    )}
                  </div>
                  <div className="job-board-message-lir__time">
                    {entryTime.format('MM-DD-YYYY')} @{entryTime.format('HH:mm')}
                  </div>
                  <div className="job-board-message-lir__message">
                    {logEntry.newStatus ? (
                      <p className="m-0">
                        <FormattedMessage id={getJobBoardTranslate(logEntry.newStatus, getEntryIntlKey(logEntry))} />
                      </p>
                    ) : null}
                    <p className="m-0">{getNoteTranslate(logEntry.message, intl)}</p>
                  </div>
                  {logEntry.newStatus ? (
                    <div className="job-board-message-lir__updated">
                      <JobBoardJobLogEntryTime job={job} logEntry={logEntry} logEntries={logEntries} />
                    </div>
                  ) : null}
                </div>
              </li>
            )
          })}
        </ul>
        : renderMessageHistory(activeTab)
      }
    </div>
  )
};

JobBoardJobLogEntries.propTypes = {
  job: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const { pingPilotAuthToken, fabricatorId } = state.auth;
  const {language} = state.dashboardState;
  return {
    loadingLogEntries: ownProps.job.loadingLogEntries,
    loadingMessageHistory: ownProps.job.loadingMessageHistory,
    pingPilotAuthToken,
    fabricatorId,
    language
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showLogWindow: (data) => dispatch(basicAction(JOB_BOARD_SHOW_LOG_WINDOW, data)),
  }
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobBoardJobLogEntries)
)
